import ScanList from "./ScanList";
import ScanCreate from "./ScanCreate";
import ScanEdit from "./ScanEdit";


const scans = {
  list: ScanList,
  create: ScanCreate,
  edit: ScanEdit,
};

export default scans;